if (!customElements.get('deferred-media')) {
  class DeferredMedia extends HTMLElement {
    constructor() {
      super();
      const poster = this.querySelector('[id^="Deferred-Poster-"]');
      if (!poster) return;
      poster.addEventListener('click', this.loadContent.bind(this));
    }
  
    pauseVideos() {
      document.querySelectorAll('.js-youtube').forEach((video) =>
        video.contentWindow.postMessage(
          '{"event":"command","func":"pauseVideo","args":""}',
          '*'
        )
      );
  
      document.querySelectorAll('.js-vimeo').forEach((video) =>
        video.contentWindow.postMessage('{"method":"pause"}', '*')
      );
  
      document.querySelectorAll('video').forEach((video) => video.pause());
  
      document.querySelectorAll('.product-model').forEach((model) => {
        if (model.modelViewerUI) model.modelViewerUI.pause();
      });
    }
  
    loadContent(focus = true) {
      this.pauseVideos();
      if (!this.getAttribute('loaded')) {
        const content = document.createElement('div');
        content.innerHTML = this.querySelector('template').innerHTML;
  
        this.setAttribute('loaded', true);
        const deferredElement = content.querySelector('video, model-viewer, iframe');
        if (focus) deferredElement.focus();
        if (deferredElement.nodeName === 'VIDEO' && deferredElement.getAttribute('autoplay')) {
          deferredElement.play();
        }
  
        this.appendChild(deferredElement);
      }
    }
  }
  
  customElements.define('deferred-media', DeferredMedia);
  
  
}
